import CallServiceTable from "../../../components/Tables/CallServiceTable";
import { Button } from "../../../components/Buttons";
import { GenerateRoadmapPDF } from "../../../containers/ManegeProcedure/GenerateRoadmapPDF";
import { useDialog } from "../../../contexts/DialogContext";
import { headerList } from "../../../utils/constant";
import { useModal } from "../../../contexts/ModalContext";
import { FormQuotes } from "../../../containers/ManegeProcedure/FormQuotes";
import NewProcedure from "../../../containers/steps/NewProcedure";
import { DialogConfirmation } from "../../../components/Modal";
import { H3 } from "../../../components/Text";
import { SendProcedure } from "../../../containers/steps";
import { useParams } from "react-router-dom";

const Quotes = () => {
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();
  const { rolId } = useParams();

  function generateRoadmap(procedure) {
    openDialog(
      <GenerateRoadmapPDF procedure={procedure} dialogClose={dialogClose} />
    );
  }

  function handleFormQuotes(procedure) {
    openModal(<FormQuotes procedure={procedure} />);
  }

  const newHeaderList = [
    { name: "nroQuotation", label: "Nro. cotización" },
    ...headerList,
  ];

  function handleAdd(reloadTable) {
    openModal(
      <NewProcedure
        reload={reloadTable}
        onClose={onClose}
        openModal={openModal}
        isQuotation={true}
      />
    );
  }

  function handleDelete(procedure, reload) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el tramite?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/procedure/${procedure.id}`}
        texBtn="Eliminar"
        handleSuccess={reload}
      />
    );
  }

  function handleSendProcedure(procedure, reloadTable) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={procedure}
        reload={reloadTable}
        onClose={onClose}
      />
    );
  }

  return (
    <CallServiceTable
      component={({ reload }) => {
        return (
          <Button onClick={() => handleAdd(reload)}>
            Agregar nueva Cotización
          </Button>
        );
      }}
      // onClick={handleFillForm}
      filters={[
        {
          name: "procedureType",
          url: "/procedureType",
          default: "Todos los tramites",
          valueOption: "id",
          labelOption: "name",
        },
        // {
        //   name: "Year",
        //   default: "Todas las gestiones",
        //   options: [
        //     {
        //       label: "2025",
        //       name: "2025",
        //       initial: true,
        //     },
        //     {
        //       label: "2024",
        //       name: "2024",
        //     },
        //     {
        //       label: "2023",
        //       name: "2023",
        //     },
        //     {
        //       label: "2022",
        //       name: "2022",
        //     },
        //     {
        //       label: "2021",
        //       name: "2021",
        //     },
        //   ],
        // },
        {
          name: "companyId",
          url: "/company/getallcompanies",
          default: "Todas las compañías",
          valueOption: "id",
          labelOption: "razonSocial",
        },
      ]}
      urlApi={`/procedure/bystepbyproceduretypeid/${0}/proceduretypeid/${0}/rol/${rolId}`}
      addFilters={[
        {
          name: "procedureNumber",
          label: "Tramite",
          filter: true,
        },
        {
          name: "internCode",
          label: "Nro. interno",
          filter: true,
        },
        {
          name: "dimNumber",
          label: "Nro. DIM/DEX",
          filter: true,
        },
        {
          name: "númeroDePedido",
          label: "Nro. de Pedido",
          filter: true,
        },
      ]}
      header={[
        ...newHeaderList,
        {
          name: "Reports",
          type: "action",
          label: "Reportes",
          sticky: true,
          actions: [
            {
              label: "Generar hoja de ruta",
              icon: "fas fa-route",
              action: generateRoadmap,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Cotización",
              icon: "fas fa-hand-holding-usd",
              action: handleFormQuotes,
              color: "text-[#1d4ed8]",
            },
            {
              label: "Enviar",
              icon: "fas fa-share-square",
              action: handleSendProcedure,
              color: "text-green-600",
            },
            {
              label: "Eliminar cotización",
              icon: "fas fa-trash",
              action: handleDelete,
              color: "text-red-500",
            },
          ],
        },
      ]}
    />
  );
};

export default Quotes;
